var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (
    _vm.has_perm('create_customer') ||
      _vm.GET_ACCOUNT_DATA.id == 1 ||
      _vm.has_perm('update_customer')
  )?_c('div',[_c('div'),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.add_personal === true)?_c('customer-add-personal',{attrs:{"customer_id":_vm.customer_id,"callback":_vm.callback,"resident_type":'tenant'}}):_vm._e(),_vm._v(" "),(_vm.add_company === true)?_c('customer-add-company',{attrs:{"customer_id":_vm.customer_id,"callback":_vm.callback,"resident_type":'tenant'}}):_vm._e()],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-42e71a04","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Customer/CustomerAdd.vue
// module id = null
// module chunks = 